import React, { Component } from 'react'
import { Navbar, Nav, Container, Button, Dropdown, Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import bootstrap from 'bootstrap'
import FeatherIcon from 'feather-icons-react';
import CusCard from '../components/CusCard'
import '../../node_modules/font-awesome/css/font-awesome.min.css'
import { Row } from 'react-bootstrap';
import CustomFooter from '../components/Footer';
import CustomHeader from '../components/Header'



class Administration extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (

            <Container>

                {/* <CustomHeader></CustomHeader> */}




                <Row>
                    {/* <CusCard data1="My" data2="Profile" icon="user" link="./UpdateUserProfile"></CusCard> */}
                    {/* <CusCard data1="Add New" data2="User" icon="user-plus" link="./AddNewUser"></CusCard> */}
                    <CusCard data1="Change" data2="Password" icon="lock" link="./UpdatePassword"></CusCard>
                    <CusCard data1="Activity" data2="Log" icon="activity" link="./ActivityLog"></CusCard>
                </Row>



            </Container>

        );
    }
}


export default Administration;